import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const ScoreCalculator = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-secondary/10 to-brand-primary/5 pt-24 pb-24">
      <div className="container mx-auto px-4">
        {/* relative sınıfı önemli, içindeki absolute eleman buna göre konumlanacak */}
        <Card className="max-w-4xl mx-auto relative overflow-hidden border-brand-primary/10 shadow-2xl bg-white">

          {/* --- KATMAN 2 (EN ÜST): ÇOK YAKINDA OVERLAY --- */}
          {/* z-20 vererek kesinlikle en üstte olmasını sağladık */}
          <div className="absolute inset-0 z-20 flex flex-col items-center justify-center bg-white/60 backdrop-blur-md">
            <div className="text-center p-10 bg-white/95 rounded-3xl shadow-xl border border-brand-primary/10 max-w-sm mx-4 transform transition-transform hover:scale-105">
              <h2 className="text-5xl font-handwriting text-brand-primary mb-4">Çok Yakında!</h2>
              <p className="text-brand-primary/80 font-medium leading-relaxed">
                Puan hesaplama sistemimiz YKS 2026 verileriyle güncelleniyor. Takipte kalın!
              </p>
              <div className="mt-6 w-12 h-1 bg-brand-secondary mx-auto rounded-full opacity-50" />
            </div>
          </div>
          {/* -------------------------------------------------- */}


          {/* --- KATMAN 1 (ALT): BLURLANACAK İÇERİK --- */}
          {/* relative ve z-0 vererek altta kalmasını garantiye aldık */}
          <div className="relative z-0 opacity-50 pointer-events-none select-none">
            <CardHeader>
              <CardTitle className="text-2xl">YKS Puan Hesaplama</CardTitle>
              <CardDescription>2026 Verileriyle Yakında Hizmetinizde</CardDescription>
            </CardHeader>

            <CardContent className="pb-20">
              <Alert className="mb-6 bg-brand-primary/5 border-brand-primary/20">
                <AlertTitle className="text-brand-primary">Sistem Güncelleniyor</AlertTitle>
              </Alert>
              {/* İçerik varmış gibi görünen placeholderlar */}
              <div className="space-y-6">
                <div className="grid grid-cols-2 gap-4">
                  <div className="h-12 bg-gray-100 rounded-lg animate-pulse" />
                  <div className="h-12 bg-gray-100 rounded-lg animate-pulse" />
                </div>
                <div className="h-40 bg-gray-50 border-2 border-dashed border-gray-200 rounded-lg animate-pulse flex items-center justify-center text-gray-400">
                  TYT / AYT Form Alanı
                </div>
                <div className="h-60 bg-brand-primary/5 rounded-lg animate-pulse flex items-center justify-center text-brand-primary/30 font-bold text-xl">
                  Sonuç Ekranı
                </div>
              </div>
            </CardContent>
          </div>
          {/* ----------------------------------------- */}

        </Card>
      </div>
    </div>
  );
};

export default ScoreCalculator;